import { useInvalidatePortfolios } from '@/entities/portfolio';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useDeletePortfolioCategory = () => {
  const mutation = trpc.portfolioManagement.categories.delete.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidatePortfolios());
  return { ...action, deleteCategory: action.execute };
};
